import { NotificationsRoutes } from "./notifications/notificationsRoute";
import { CreateNotificationRoutes } from "./createNotification/createNotificationRoute";
import { messagesRoutes } from "./messages/messagesRoute";
import { createMessageRoutes } from "./createMessage/createMessageRoute";
import { financialReportsRoute } from "./financialManagements/financialReports/financialReportsRoutes";
import { chargeWalletRoutes } from "./chargeWallet/chargeWalletRoutes";
import { depositRoutes } from "./financialManagements/financialRecords/deposit";
import { profileDoctorRoutes } from "./doctorProfile/doctorProfile";
import { commentsRoutes } from "./comments/commentsRoutes";
import { assignStaffToDoctorRoutes } from "./assignStaff/assignStaffRoutes";
import { doctorFinancialRecordsRoutes } from "./financialManagements/financialRecords/doctorFinancialRecordsRoutes";
import { patientsRoutes } from "./patientManagement/patientsRoutes";
import { myDoctorsRoutes } from "./myDoctors/myDoctorsRoutes";

import { storedResultRoutes } from "@routes/storedResult/storedResultRoutes";
import { pastMedicalHistoryRoutes } from "@routes/pastMedicalHistory/pastMedicalHistoryRoutes";
import { intakeFormRoutes } from "@routes/intakeForm/intakeFormRoutes";
import { hfRoutes } from "@routes/hf/hfRoutes";
import { usersRoutes } from "@routes/userManagement/usersRoutes";
import { financialRoutes } from "@routes/financial/financialRoutes";
import { myPatientsRoutes } from "@routes/myPatients/myPatientsRoute";
import { profileManagementRoutes } from "@routes/profileManagement/profileRoutes";
import { appointmentRoutes } from "@routes/appointment/appointmentRoutes";
import { summaryNoteRoutes } from "@routes/summaryNotes/summaryNoteRoutes";
import { myFamilyRoutes } from "@routes/myFamily/myFamilyRoute";
import { financialRecordsRoutes } from "@routes/financialManagements/financialRecords/financialRecordsRoutes";
import { walletBalanceRoutes } from "@routes/financialManagements/financialRecords/walletBalance";
import { availabilityTimeRoutes } from "@routes/availabilityTime/availabilityTimeRoutes";
import { notificationSettingsRoutes } from "@routes/notificationSettings/notificationSettingsRoute";
import { withdrawRoutes } from "@routes/financialManagements/financialRecords/withdraw";
import { changePasswordRoutes } from "@routes/changePassword/changePasswordRoutes";
import { myStaffsRoute } from "@routes/doctorStaff/doctorStaffRoute";
import { patternsRoutes } from "@routes/patterns/patternsRoutes";
import { healthRecordRoutes } from "@routes/healthRecord/healthRecordRoutes";
import { reportsRoutes } from "@routes/reports/reportsRoutes";
import { mspRoutes } from "@routes/msp/mspRoutes";
import { languageSettingsRoutes } from "@routes/languageSettings/languageSettingsRoute";

export const routes = [
  ...hfRoutes,
  ...usersRoutes,
  ...financialRoutes,
  ...myPatientsRoutes,
  ...profileManagementRoutes,
  ...appointmentRoutes,
  ...summaryNoteRoutes,
  ...myFamilyRoutes,
  ...storedResultRoutes,
  ...pastMedicalHistoryRoutes,
  ...financialRecordsRoutes,
  ...walletBalanceRoutes,
  ...availabilityTimeRoutes,
  ...intakeFormRoutes,
  ...notificationSettingsRoutes,
  ...withdrawRoutes,
  ...changePasswordRoutes,
  ...myStaffsRoute,
  ...patternsRoutes,
  ...NotificationsRoutes,
  ...CreateNotificationRoutes,
  ...messagesRoutes,
  ...createMessageRoutes,
  ...financialReportsRoute,
  ...chargeWalletRoutes,
  ...depositRoutes,
  ...healthRecordRoutes,
  ...profileDoctorRoutes,
  ...commentsRoutes,
  ...assignStaffToDoctorRoutes,
  ...doctorFinancialRecordsRoutes,
  ...patientsRoutes,
  ...myDoctorsRoutes,
  ...reportsRoutes,
  ...mspRoutes,
  ...languageSettingsRoutes,
];
